





































































import { Vue, Component } from 'vue-property-decorator';
import { OPTHINES } from './config';
import { getBaseInfo } from './api/index';
import { getNewslist, getDeanslist, getOutpatientlist } from './api/index';
@Component({
  components: {
  },
})
export default class News extends Vue {
  option = OPTHINES;
  baseInfo = {};
  finished = false;
  page = 1;
  getNewsList: any[] = [];
  getDeanslist: any[] = [];
  getOutpatientlist: any[] = [];

  created() {
    getBaseInfo().then((res: any) => {
      this.$addPv(res.data.activityId);
      this.baseInfo = res.data;
    });
    getNewslist(this.option.voteName, this.page).then((res) => {
      this.getNewsList = res.data;
    });
    getDeanslist(this.option.voteName, this.page).then((res) => {
      this.getDeanslist = res.data;
    });
    getOutpatientlist(this.option.voteName, this.page).then((res) => {
      this.getOutpatientlist = res.data;
    });
  }
  newsListWindowHref(item: any) {
    window.location.href = item.titleurl || item.targetUrl;
  }
  // 锚点跳转
  goAnchor(selector: any, index: number) {
      document.body.scrollTop = this.$el.querySelector(selector).offsetTop;
      document.documentElement.scrollTop = this.$el.querySelector(
        selector,
      ).offsetTop;
  }

}
